import {FC} from 'react';
import {Control, Controller} from 'react-hook-form';
import Input from '@atomaro/ui-kit/components/Input/Input';
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import {
  HivesFiltersItem as Box,
  HivesFiltersItemTitle as Title,
  HivesFiltersRangeItemBody as Body,
  HivesFiltersRangeItemFooter as Footer,
} from 'features/hives/ui/styles';
import {HivesFiltersFormValues} from 'features/hives/lib/useHivesFilters';

type Props = {
  name: string;
  control: Control<HivesFiltersFormValues>;
  fieldNames: {from: keyof HivesFiltersFormValues; to: keyof HivesFiltersFormValues};
  onChange: (name: keyof HivesFiltersFormValues, value: string) => void;
  onSubmitClick?: () => void;
  onResetClick?: () => void;
  showFooter?: boolean;
  showReset?: boolean;
};

export const HivesFiltersRangeItem: FC<Props> = ({
  name,
  control,
  fieldNames,
  onChange,
  onSubmitClick,
  onResetClick,
  showFooter,
  showReset,
}) => {
  return (
    <Box>
      <Title>
        <span>{name}</span>
        {showReset && (
          <button type="button" onClick={onResetClick}>
            Сбросить
          </button>
        )}
      </Title>
      <Body>
        <Controller
          control={control}
          name={fieldNames.from}
          rules={{pattern: /\d/g}}
          render={({field}) => (
            <Input
              name={field.name}
              value={(field.value as string) || ''}
              label="От"
              onChange={(e) => onChange(field.name, e.target.value)}
              inputMode="numeric"
              onFocus={(e) => e.target.select()}
            />
          )}
        />
        <Controller
          control={control}
          name={fieldNames.to}
          rules={{pattern: /\d/g}}
          render={({field}) => (
            <Input
              name={field.name}
              value={(field.value as string) || ''}
              label="До"
              onChange={(e) => onChange(field.name, e.target.value)}
              inputMode="numeric"
              onFocus={(e) => e.target.select()}
            />
          )}
        />
      </Body>
      {showFooter && (
        <Footer>
          <Button label="Отменить" variant="ghost" colorScheme="neutral" onClick={onResetClick} />
          <Button label="Применить" onClick={onSubmitClick} />
        </Footer>
      )}
    </Box>
  );
};
